const { access_token: accessToken, uid, reservation_restaurant_id: restaurantId } = parseParamsURL(location.search)

export const appAccessInfo = {
  accessToken,
  uid,
  restaurantId
}

export const isWebView = appAccessInfo.accessToken && appAccessInfo.uid

export function parseParamsURL (urlHashString) {
  const result = {}
  urlHashString.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      result[key] = decodeURIComponent(value)
  })
  return result
}
